// extracted by mini-css-extract-plugin
export default {"productDetail":"ProductVersionDetails_productDetail__BuDjJ","product-footer-transition":"ProductVersionDetails_product-footer-transition__mIlyd"};